import Tooltip from 'components/tooltip/Tooltip';
import {
  AutomatedReviewLog,
  AutomatedReviewLogChannel,
} from 'models/automation/Reviews';
import { Row } from '@tanstack/react-table';
import VrboIcon from 'assets/images/icons/channels/vrbo.svg?react';
import AirbnbIcon from 'assets/images/icons/channels/airbnb.svg?react';
import HostfullyIcon from 'assets/images/icons/channels/hostfully.svg?react';
import { useTranslation } from 'react-i18next';
import { ChannelCellStyled } from './ChannelCell.styles';

const CHANNEL_ICON_MAP = {
  [AutomatedReviewLogChannel.AIRBNB]: (
    <AirbnbIcon data-testid="channel-icon-airbnb" />
  ),
  [AutomatedReviewLogChannel.VRBO]: (
    <VrboIcon data-testid="channel-icon-vrbo" />
  ),
  [AutomatedReviewLogChannel.HOSTFULLY]: (
    <HostfullyIcon data-testid="channel-icon-hostfully" />
  ),
};

const ChannelCell = ({ row }: { row: Row<AutomatedReviewLog> }) => {
  const { t } = useTranslation();
  const { channel } = row.original;

  return (
    <Tooltip
      id={`channel-${channel ?? 'unknown'}-tooltip`}
      text={t('pageAutomations.reviews.automatedReviewLogs.channels.channel', {
        context: channel,
      })}
    >
      <ChannelCellStyled>
        {CHANNEL_ICON_MAP[channel] ??
          t(
            'pageAutomations.reviews.automatedReviewLogs.table.channelNotFound',
          )}
      </ChannelCellStyled>
    </Tooltip>
  );
};

export default ChannelCell;
